import type { PropsWithChildren } from 'react';

import { createContextFactory } from '@mfw/components';
import React from 'react';

import { useRouterBreadcrumbs } from '../../router/hooks';

export type BreadcrumbsContextType = ReturnType<typeof useRouterBreadcrumbs>;

const BreadcrumbsContext = createContextFactory({
  devToolsName: 'BreadcrumbsContext',
  initialValue: {} as BreadcrumbsContextType,
});

const BreadcrumbsProvider = ({ children }: PropsWithChildren) => {
  const { breadCrumbTitles, matches, setBreadCrumbTitle } =
    useRouterBreadcrumbs();

  const providedValues = React.useMemo(() => {
    return { breadCrumbTitles, matches, setBreadCrumbTitle };
  }, [matches, setBreadCrumbTitle, breadCrumbTitles]);
  return (
    <BreadcrumbsContext.Provider value={providedValues}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};

export default BreadcrumbsProvider;

export function useBreadcrumbsContext() {
  return BreadcrumbsContext.useContext();
}
